import { BookkeepingCheckboxList } from "components/CheckboxList/BookkeepingCheckboxList";
import CulturesTemplateDropdown from "components/dropdowns/reactselect/CulturesTemplateDropdown";
import { WordTemplateFilePanelNew } from "components/FileUpload/SingleFilePanel";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { YesNoRadioGroupForInPageEditing } from "components/ValidatedFields/YesNoRadioGroup";
import React, { useState } from "react";
import { uploadFileToCoreApi } from "utilities/fileUploadUtils";
import { routes } from "utilities/routing/generatedRoutes";
import { WordTemplateNewInfo } from "./models";

interface WordTemplateNewSectionProps {
  mainAreaId: server.dto.MainAreas
  availableBookkeepings: server.dto.BookkeepingSmall[]
  displayVisibleToExternal: boolean
  displayReadyForESign: boolean
  displayVisibleBookkeeping: boolean
}

export const WordTemplateNewSection = (props: WordTemplateNewSectionProps) => {
  const [value, setValue] = useState<WordTemplateNewInfo>({
    title: "",
    visible: true,
    lcid: site.currentUser.culture,
    eSignReady: props.displayReadyForESign,
    visibleToExternal: false,
    file: null,
    bookkeepingIds: [],
  });

  const onChange = (newData: Partial<WordTemplateNewInfo>) => {
    setValue({ ...value, ...newData });
  };

  const submit = () => {
    return uploadFileToCoreApi(
      window.CoreApi.WordTemplate.Create,
      window.CoreApi.WordTemplate.Create.absoluteUrl(),
      {
        toBookkeepingIds: value.bookkeepingIds,
        culture: value.lcid,
        eSignReady: value.eSignReady,
        file: value.file,
        mainAreaId: props.mainAreaId,
        title: value.title,
        visibleToExternal: value.visibleToExternal,
      },
      {
        fileType: "docx",
        timeout: 60000,
      }
    );
  }

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={() => routes.wordTemplate_List(props.mainAreaId).absolute}
    sections={[{
      key: "wordTemplate",
      type: "regular",
      title: RESX.WordTemplate.resxWordTemplate,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        renderEditNew: () => <RequiredTextInput
          validatorKey="title"
          focusOnMount
          maxLength={serverReference.constants.wordTemplate.maxTitleLength}
          value={value.title}
          onChange={(title) => { onChange({ title }); }}
        />
      }, {
        key: "lcid",
        label: RESX.Language.resxLanguage,
        renderEditNew: () => <CulturesTemplateDropdown
          value={value.lcid}
          onChange={(lcid) => onChange({ lcid })}
        />
      }, {
        key: "eSignReady",
        label: RESX.ESign.eSignReady,
        hidden: !props.displayReadyForESign,
        renderEditNew: () => <YesNoRadioGroupForInPageEditing
          value={value.eSignReady}
          onChange={(eSignReady) => onChange({ eSignReady })}
        />,
      }, {
        key: "visibleToExternal",
        label: RESX.GeneralLabels.VisibleToExternalUsers,
        hidden: !props.displayVisibleToExternal,
        renderEditNew: () => <YesNoRadioGroupForInPageEditing
          value={value.visibleToExternal}
          onChange={(visibleToExternal) => onChange({ visibleToExternal })}
        />,
      }]
    }, {
      key: "file",
      type: "custom",
      render: () => <WordTemplateFilePanelNew
        key="files-panel"
        selected={value.file}
        onSelected={(file) => onChange({ file })}
      />
    }, {
      key: "bookkeepings",
      type: "collapsable",
      hidden: !props.displayVisibleBookkeeping,
      title: RESX.GeneralLabels.Visible,
      fields: [{
        key: "bookkeepings",
        hideLabel: true,
        label: RESX.Bookkeeping.resxBookkeeping,
        renderEditNew: () => <BookkeepingCheckboxList
          availableBookkeepings={props.availableBookkeepings}
          selectedBookkeepingIds={value.bookkeepingIds}
          onChanged={(bookkeepingIds) => onChange({ bookkeepingIds })}
        />
      }]
    }]}
  />
}